'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactBootstrap = require('react-bootstrap');

var ReactBootstrap = _interopRequireWildcard(_reactBootstrap);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Vegetable Serve information
 */
var MeatServe = function (_Component) {
  (0, _inherits3.default)(MeatServe, _Component);

  function MeatServe() {
    (0, _classCallCheck3.default)(this, MeatServe);
    return (0, _possibleConstructorReturn3.default)(this, (MeatServe.__proto__ || (0, _getPrototypeOf2.default)(MeatServe)).apply(this, arguments));
  }

  (0, _createClass3.default)(MeatServe, [{
    key: 'render',
    value: function render() {
      var meatServe = require('../Assets/meatserve.png');

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'strong',
          null,
          'One serve is equivalent to:'
        ),
        _react2.default.createElement(
          'ul',
          null,
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'span',
              null,
              '65g cooked lean red meats such as beef, lamb, veal, pork, goat or kangaroo (about 90-100g raw)'
            )
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'span',
              null,
              '80 g cooked lean poultry such as chicken or turkey (100g raw)'
            )
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'span',
              null,
              '100g cooked fish fillet (about 115g raw) or one small can of fish'
            )
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'span',
              null,
              '2 large (120g) eggs'
            )
          ),
          _react2.default.createElement(
            'strong',
            null,
            'Or:'
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'span',
              null,
              '1 cup (150g) cooked or canned legumes/beans such as lentils, chick peas or split peas (preferably with no added salt)'
            )
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'span',
              null,
              '170g tofu'
            )
          ),
          _react2.default.createElement(
            'li',
            null,
            _react2.default.createElement(
              'span',
              null,
              '30g nuts, seeds, peanut or almond butter or tahini or other nut or seed paste (no added salt)'
            )
          )
        ),
        _react2.default.createElement(ReactBootstrap.Image, { src: meatServe, responsive: true, className: 'center-block' })
      );
    }
  }]);
  return MeatServe;
}(_react.Component);

exports.default = MeatServe;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ServeInformation/MeatServe/MeatServe.js
// module id = 1267
// module chunks = 0